import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DateLocaleService {
  private currentLocaleSubject = new BehaviorSubject<string>('en');
  public currentLocale$ = this.currentLocaleSubject.asObservable();

  constructor() {
    // Initialize with language from localStorage or default to 'en'
    const lang = localStorage.getItem('lang') || 'en';
    this.setLocale(lang);
  }

  setLocale(language: string): void {
    // Map language codes to locale codes for date formatting
    const localeMap: { [key: string]: string } = {
      'en': 'en-US',
      'fr': 'fr-FR',
      'it': 'it-IT'
    };

    // Extract the base language code (e.g., 'en' from 'en_US')
    const baseLang = language.split('_')[0].toLowerCase();
    const locale = localeMap[baseLang] || 'en-US';
    
    this.currentLocaleSubject.next(locale);
  }

  getCurrentLocale(): string {
    return this.currentLocaleSubject.value;
  }
}
